var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultVCheckbox',_vm._b({attrs:{"boolean":""},on:{"input":(e) => _vm.$emit('input', e),"click":(e) => _vm.$emit('click', e)},model:{value:(_vm.isChecked),callback:function ($$v) {_vm.isChecked=$$v},expression:"isChecked"}},'DefaultVCheckbox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }